var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/shop-remove"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop-remove"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.09995 25.8417C6.00828 25.8417 3.48828 23.3333 3.48828 20.23V16.9167C3.48828 16.135 4.25828 15.61 4.99328 15.8667C5.29661 15.9717 5.59995 16.0417 5.91495 16.0883C6.05495 16.1117 6.19495 16.135 6.33495 16.135C6.50995 16.1583 6.69661 16.17 6.87161 16.17C8.16661 16.17 9.44995 15.6917 10.4649 14.8633C11.4333 15.6917 12.6816 16.17 14.0116 16.17C15.3416 16.17 16.5783 15.715 17.5466 14.875C18.5499 15.6917 19.8099 16.17 21.0933 16.17C21.2916 16.17 21.5016 16.1583 21.6883 16.135C21.8283 16.1233 21.945 16.1117 22.0733 16.0883C22.4233 16.0417 22.7383 15.9483 23.0533 15.8433C23.7766 15.5983 24.535 16.135 24.535 16.8933V20.23C24.535 23.3217 22.0266 25.8417 18.9233 25.8417H9.09995Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.6433 10.0217L25.3167 6.91833C24.85 3.53499 23.31 2.15833 20.0317 2.15833H7.95666C4.66666 2.15833 3.13832 3.53499 2.65999 6.95333L2.35666 10.0333C2.23999 11.235 2.56666 12.4017 3.27832 13.3117C4.12999 14.42 5.43666 15.05 6.89499 15.05C8.30666 15.05 9.65999 14.3383 10.5233 13.2067C11.2817 14.3383 12.5767 15.05 14.0233 15.05C15.47 15.05 16.7417 14.3733 17.5117 13.2533C18.375 14.3617 19.7167 15.05 21.105 15.05C22.5983 15.05 23.94 14.385 24.78 13.2183C25.4567 12.32 25.76 11.1883 25.6433 10.0217ZM15.75 9.01833H12.25C11.7717 9.01833 11.375 8.63333 11.375 8.14333C11.375 7.66499 11.7717 7.26833 12.25 7.26833H15.75C16.2283 7.26833 16.625 7.66499 16.625 8.14333C16.625 8.63333 16.2283 9.01833 15.75 9.01833Z",
    fill: "#AAAAAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopRemove);
export default __webpack_public_path__ + "static/media/shop-remove.a008ee83aa0a51a3c75b53c11e0eaf49.svg";
export { ForwardRef as ReactComponent };